import React, { useEffect } from 'react';
import { Divider, Table, TableBody, TableContainer, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getQuoteProProductsBySearchCriteriaApi, getQuoteProductSubscriptionOptionsApi } from 'api';
import QuoteAutomationItemsTableRow from '../QuoteAutomation/QuoteAutomationItemsTableRow';
import { useStyles } from '../styles';


const QuoteScheduleDetails = ({ products, notes }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    subscriptionOptionsBySku,
    quoteProducts
  } = useSelector((state: IReduxState) => state.quote);
  const { autoQuoteItems } = useSelector((state: IReduxState) => state.automatedQuotes);

  useEffect(() => {
    if (autoQuoteItems?.length) {
      autoQuoteItems?.map((item) => {
        const {sku} = item;

        if (!subscriptionOptionsBySku?.[sku] && sku) {
          getQuoteProductSubscriptionOptionsApi({ dispatch, sku });
        }
      });
    }
  }, [autoQuoteItems]);

  useEffect(() => {
    if (!quoteProducts.length) {
      getQuoteProProductsBySearchCriteriaApi({
        dispatch,
        sortDirection: 'asc',
        sortField: 'name',
        pageSize: '',
        currentPage: '',
        filterConditions: [
          {
            field: 'status',
            value: '1',
            conditionType: 'eq'
          },
        ],
        searchConditions: []
      });
    }
  }, []);

  return (
    <TableContainer>
      <Table className={classes.selectedItemsTable}>
        <TableBody className={classes.quoteSummaryTable}>
          {products?.map((item, id) => (
            <QuoteAutomationItemsTableRow
              key={`${id}-${item.sku}`}
              item={item}
            />
          ))}
        </TableBody>
      </Table>
      {notes && (
        <div className="my-2 p-2">
          <Divider />
          <Typography variant="h6">
            Notes:
          </Typography>
          <Typography variant="body2">
            {notes}
          </Typography>
        </div>
      )}
      <Divider />
    </TableContainer>
  );
};

export default QuoteScheduleDetails;
